import React from "react";
import styles from '../CareersFolder/Careers.module.css'
import { useState , useRef , useEffect} from 'react';
import { Link } from 'react-router-dom'
import Footer from '../FooterFolder/Footer';
import AOS from "aos";
import 'aos/dist/aos.css'



export default function Home() {

 /////////////////////////////////////////////////
  useEffect(() => {
    AOS.init({duration: 1500})
  
  }, [])
/////////////////////////////////////////////////
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };

  const [showScroll, setShowScroll] = useState(false)

  const checkScrollTop = () => {    
   if (!showScroll && window.pageYOffset > 350){
      setShowScroll(true)    
   } else if (showScroll && window.pageYOffset <= 350){
      setShowScroll(false)    
   }  
};

  window.addEventListener('scroll', checkScrollTop)

  const ScrollArrow = () =>{
  const [showScroll, setShowScroll] = useState(false)

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 350){
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 350){
      setShowScroll(false)
    }
    }
  };  

  window.addEventListener('scroll', ScrollArrow)
  
  const scrollTop = () =>{
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  window.addEventListener('scroll', checkScrollTop)

 
  
  return (

    <>
<section className="container mt-5 pt-5 vh-100">
    <div className="row d-flex justify-content-center align-items-center">
        <div className="col-md-12 ">
        
                    <h2 className='text-center fs-1 fw-bolder position-relative mainColor mt-5' >
                    Careers
                    <div className={`${styles.middleTric} position-absolute top-0 start-50 translate-middle `}> c </div>
                    <div className="shortline mt-2"></div>
                    <div className="longline"></div>
                    <div className="shortline mb-2"></div>
                </h2>
                <p className='text-center mt-3 fs-5 text-muted'> To apply for a job with <span className={`${styles.color} fs-4`}> ACH </span>  please send your C.V. to: </p>
                <p className='text-center'> <a href="mailto:info@achegy.com" className={`${styles.anchorColor} fs-5`}> info@achegy.com </a>  </p>
            
        </div>
          <div className="shortline mt-2"></div>
        <div className="longline"></div>
        <div className="shortline mb-2"></div>
    </div>
             <div className="col-md-12 mt-5" id='career'>
      <h2 className='text-center fs-4 fw-bolder position-relative mainColor'>
        You Can Follow Us On Our Platforms 
    <div className={`${styles.middleTric} position-absolute top-0 start-50 translate-middle `}> s </div>
    <div className="shortline mt-2"></div>
        <div className="longline"></div>
        <div className="shortline mb-2"></div>
      </h2>


      <div className={`${styles.social} d-flex justify-content-center align-items-center my-3`}>
            
                <div className='my-3'>  <Link to='https://www.facebook.com/ach.decorations?mibextid=LQQJ4d' target={"_blank"}> <i className="fa-brands fa-facebook fs-2 mx-2"> </i> </Link>  </div> 
                <div className='my-3'>  <Link to='https://instagram.com/ach___0?igshid=YmMyMTA2M2Y=' target={"_blank"}><i className="fa-brands fa-instagram fs-2 mx-2"></i></Link>  </div> 
                <div className='my-3'>  <Link to='https://www.linkedin.com/company/architecture-consulting-house/' target={"_blank"}> <i className="fa-brands fa-linkedin fs-2 mx-2"></i> </Link></div> 
   
      </div>
  </div>
</section>

<Footer/>  
    </>
  )
}
